import React from 'react';

/**
 * Marks a sysadmin-only assistant: one that works on the platform itself (the
 * Documentation Manager, a management assistant). Only sysadmins can open it,
 * whether or not it is published, so only they ever see this.
 */
const SysAdminOnlyBadge: React.FC = () => (
    <span
        className="badge text-bg-dark fw-normal"
        title="Sysadmin only: only system administrators can see and use this assistant"
    >
        sysadmin only
    </span>
);

export default SysAdminOnlyBadge;
